import { Grid } from '@mui/material'
import React from 'react'
import Startup from '../../../../models/startup'
import StartupAssetsSection from './StartupAssetsSection'
import StartupDetailsScoreSection from './StartupDetailsScoreSection'
import StartupInfoSection from './StartupInfoSection'

interface Props {
  startup: Startup
  logoUrl?: string
  deckUrl?: string
  onEditStartupPressed: () => void
  onRateStartupPressed: () => void
  onViewAllScoresPressed: () => void
}

const StartupDetailsView = (props: Props) => {
  return (
    <Grid container spacing={2}>

      <Grid item xs={12}>
        <StartupDetailsScoreSection 
          startup={props.startup} 
          logoUrl={props.logoUrl} 
          onEditStartupPressed={props.onEditStartupPressed} 
          onScoreNowPressed={props.onRateStartupPressed}
          onViewAllScoresPressed={props.onViewAllScoresPressed}
        />
      </Grid>

      <Grid item xs={6}>
        <StartupInfoSection startup={props.startup} />
      </Grid>

      <Grid item xs={6}>
        <StartupAssetsSection pitchDeckUrl={props.deckUrl} videoUrl={props.startup.videoUrl} />
      </Grid>

    </Grid>
  )
}

export default StartupDetailsView
